var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreeGraft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 452.358,
    height: 207.844,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(61.51 7.054)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 5.1198144 10.239629 15.359444 17.91935 20.479258 27.650585 32.253933 36.353371",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "publickey")), /*#__PURE__*/React.createElement("path", {
    d: "M2.41-8.926a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(76.42 28.891)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M-33.873-21.628h67.746L0-8.926l-33.873-12.702",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.463-44.124a2.41 2.41 0 1 1-4.819 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(31.257 75.822)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M-50.808-56.826h33.873l-16.937 12.702-16.936-12.702",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.935-56.826h33.873L33.872-44.124",
    style: {
      fill: "#d9d9d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.282-44.124a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(121.581 75.822)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M16.935-56.826h33.873L33.872-44.124 16.935-56.826",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.397-70.853a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(8.677 112.588)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M-63.508-83.554h25.405l-12.704 12.701-12.701-12.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.525-70.853a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(53.84 112.588)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M-29.637-83.554h25.405l-12.703 12.701-12.702-12.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.216-70.853a2.41 2.41 0 1 1-4.819 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(144.161 112.588)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M38.103-83.554h25.405L50.807-70.853l-12.704-12.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.344-70.853a2.41 2.41 0 1 1-4.819 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(98.999 112.588)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M4.232-83.554h25.405L16.935-70.853l-12.703-12.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.046-97.58a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(109.645 148.788)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 5.4990931 11.19724 16.596806 20.701624",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "horst")), /*#__PURE__*/React.createElement("path", {
    d: "M8.465-110.28h42.34l-21.169 12.7-21.171-12.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.078-.167c0-.11-.096-.11-.29-.11-.027 0-.192 0-.33-.014C7.25-.318 7.25-.36 7.25-.442c0-.083.014-.152.027-.207l1.214-4.784c.069-.331.096-.414.8-.414.137 0 .247 0 .247-.151 0-.125-.096-.125-.261-.125H8.105c-.235 0-.262 0-.373.166L4.425-.842 3.68-5.888c-.028-.235-.041-.235-.29-.235H2.165c-.166 0-.276 0-.276.166 0 .11.096.11.276.11.027 0 .193 0 .33.028.18.014.221.041.221.124 0 .055-.014.083-.041.18L1.544-.954c-.125.47-.373.648-.966.676a.15.15 0 0 0-.152.165s0 .11.124.11c.11 0 .331-.013.455-.013.138-.014.152-.014.442-.014l.455.014c.151 0 .33.014.468.014.042 0 .166 0 .166-.166 0-.096-.097-.11-.18-.11-.427-.014-.578-.152-.578-.386 0-.069 0-.069.027-.193l1.213-4.88h.014l.814 5.5c.013.152.027.235.151.235.11 0 .166-.083.207-.166l3.653-5.638h.014L6.59-.677c-.083.317-.096.4-.772.4-.165 0-.276 0-.276.165 0 .07.07.11.138.11.11 0 .455-.013.565-.013.138-.014.359-.014.538-.014l.58.014c.178 0 .371.014.537.014.055 0 .18 0 .18-.166m0 0",
    "aria-label": "M",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(147.012 173.436)scale(1.13333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.841-6.687v3.708l7.9 1.393-.855-3.53 4.895 1.751v.951l3.267-.565-3.267-2.62v1.02L6.067-7.183l.91 3.268zm0 0",
    "aria-label": "z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(105.499 66.42)scale(1.13333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33.872-38.564v13.697",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-1.33333 1.33333)rotate(-89.998 -.752 29.024)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.872-38.564v13.697",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(1.33333 -1.33333)rotate(89.998 62.897 34.626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.62-2.524c0-.745-.455-1.324-1.323-1.696l-1.186-.51c-.317-.152-.648-.359-.965-.552l-1.861-1.434 2.04-1.544 2.123-.965c.703-.275 1.172-.937 1.172-1.654 0-.951-.84-1.586-2.054-1.586-1.393 0-2.454.786-2.454 1.834 0 .786.469 1.282 1.434 1.503-1.393.469-2.358.924-3.475 1.668l-5.445-3.502C2.136-11.927.62-12.45-.648-12.45q-.227 0-.29.083l8.769 5.68L5.707-5.35v.635h3.806v-.635H8.106l.91-.579 1.144.62c.62.373 1.42.718 2.358 1.021-.924.276-1.392.772-1.392 1.489 0 1.062 1.02 1.834 2.412 1.834 1.282 0 2.082-.593 2.082-1.558M4.108-4.716v-.635H.248v.635zm10.836-6.15c0 .676-.785 1.228-1.86 1.228-.814 0-1.283-.373-1.283-.98 0-.689.786-1.185 1.903-1.185.744 0 1.24.372 1.24.938m0 8.287c0 .592-.468.937-1.268.937-1.006 0-1.847-.441-1.847-1.158 0-.648.386-.938 1.213-.938 1.282.014 1.902.414 1.902 1.159m0 0",
    "aria-label": "s",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(127.648 55.831)scale(1.13333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.807-65.293v5.229",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-1.33333 1.33333)rotate(-89.99 25.32 38.156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.935-65.293v5.229",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-1.33333 1.33333)rotate(-89.997 8.38 55.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.935-65.293v5.229",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(1.33333 -1.33333)rotate(89.997 72.028 8.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.807-65.293v5.229",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(1.33333 -1.33333)rotate(89.99 88.969 25.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.636-92.02v5.228",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(1.33333 -1.33333)rotate(89.994 91.746 1.549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.805-118.683v5.164",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(1.33333 -1.33333)rotate(89.99 115.7 -1.224)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(180.863 110.907)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "=")), /*#__PURE__*/React.createElement("path", {
    d: "M8.686-2.233c0-.096-.069-.11-.096-.124-1.02-.276-2.096-.855-2.84-2.233-.097-.152-.11-.166-.235-.166-.082 0-.193 0-.193.11 0 .083.373.772.883 1.296H.842c-.138 0-.331 0-.331.193s.179.193.29.193h5.666c.138 0 .151 0 .234.056.18.137.593.454 1.117.661a5.2 5.2 0 0 0-1.117.648c-.083.083-.096.083-.234.083H.8c-.11 0-.29 0-.29.18 0 .192.194.192.332.192h5.363C5.695-.62 5.322.083 5.322.152c0 .11.11.11.193.11.124 0 .138 0 .235-.165.33-.62.662-.979.992-1.268.731-.662 1.545-.883 1.848-.965 0 0 .096-.028.096-.097m0 0",
    "aria-label": "\\u21D2",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(187.244 110.907)scale(1.13333)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(270.33 7.052)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 5.1198144 10.239629 15.359444 17.91935 20.479258",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "public")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(301.667 7.052)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 4.6033497 8.7027874",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "key")), /*#__PURE__*/React.createElement("path", {
    d: "M159.027-8.926a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(285.24 28.891)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M122.744-21.628h67.746L156.617-8.926l-33.873-12.702",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.155-44.124a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(240.077 75.822)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M105.81-56.826h33.872l-16.937 12.702-16.936-12.702",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.552-83.259h33.873L190.49-70.558",
    style: {
      fill: "#d9d9d9",
      fillOpacity: 0.35,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(330.403 111.066)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 0.35,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M173.552-83.259h33.873L190.49-70.558l-16.938-12.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.9-70.558a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#a6a6a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#a6a6a6",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.22-70.853a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(217.499 112.588)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M93.11-83.554h25.404L105.81-70.853l-12.7-12.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.092-70.853a2.41 2.41 0 1 1-4.819 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(262.66 112.588)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M126.98-83.554h25.405l-12.702 12.701-12.702-12.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(307.819 147.831)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 0.35,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M160.85-109.986h25.404l-12.702 12.7-12.703-12.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.962-97.285a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#a6a6a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#a6a6a6",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(352.981 147.831)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 0.35,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M194.72-109.986h25.405l-12.7 12.7-12.704-12.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.834-97.285a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "#a6a6a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#a6a6a6",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.745-38.564v13.697",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-1.33333 1.33333)rotate(-89.998 -79.06 107.335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.49-37.111V-64.54",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "2.98883,1.99255",
      strokeDashoffset: 0,
      strokeOpacity: 0.35
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    },
    transform: "matrix(0 1.33333 1.33333 0 338.851 90.593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81-65.293v5.229",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-1.33333 1.33333)rotate(-89.99 -52.989 116.48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.683-65.293v5.229",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-1.33333 1.33333)rotate(-89.997 -69.93 133.405)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.552-91.725v5.228",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    },
    transform: "scale(1.33333 -1.33333)rotate(89.997 163.554 73.655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.424-91.725.001 5.228",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    },
    transform: "scale(1.33333 -1.33333)rotate(89.99 180.496 90.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.191-56.826h33.873L220.13-44.124",
    style: {
      fill: "#ffb3b3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(369.921 75.822)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M203.191-56.826h33.873L220.13-44.124l-16.938-12.702",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.539-44.124a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.472-70.853a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "red",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(392.499 113.152)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.694314 10.799132",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M224.358-83.554h25.405l-12.7 12.701-12.705-12.7",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.17-97.58a2.41 2.41 0 1 1-4.819 0 2.41 2.41 0 0 1 4.82 0z",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "red",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(403.141 148.788)scale(1.13333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 5.4990931 11.19724 16.596806 20.701624",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "horst")), /*#__PURE__*/React.createElement("path", {
    d: "M228.589-110.28h42.34l-21.168 12.7-21.173-12.7",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.077-.165c0-.11-.096-.11-.29-.11-.027 0-.192 0-.33-.014C7.25-.316 7.25-.358 7.25-.44c0-.083.014-.152.028-.207L8.49-5.431c.069-.331.097-.414.8-.414.138 0 .248 0 .248-.151 0-.125-.097-.125-.262-.125H8.105c-.234 0-.262 0-.372.166L4.424-.84l-.745-5.046c-.027-.235-.04-.235-.289-.235H2.163c-.166 0-.276 0-.276.166 0 .11.097.11.276.11.028 0 .193 0 .33.028.18.014.221.041.221.124 0 .055-.013.083-.041.18L1.543-.95c-.125.468-.373.647-.966.675a.15.15 0 0 0-.151.166s0 .11.124.11c.11 0 .33-.014.455-.014.138-.014.151-.014.441-.014l.455.014c.152 0 .33.014.469.014.041 0 .165 0 .165-.166 0-.096-.096-.11-.18-.11-.426-.014-.578-.152-.578-.386 0-.069 0-.069.027-.193l1.214-4.88h.013l.814 5.5c.014.152.027.235.152.235.11 0 .165-.083.206-.166l3.654-5.638h.014L6.588-.675c-.082.317-.096.4-.772.4-.165 0-.275 0-.275.166 0 .068.069.11.138.11.11 0 .455-.014.565-.014.138-.014.358-.014.537-.014l.58.014c.179 0 .372.014.537.014.055 0 .18 0 .18-.166m0 0",
    "aria-label": "M",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(438.985 174.004)scale(1.13333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.929-3.004c0-.207-.18-.345-.359-.345-.193 0-.29.138-.33.262L.399-.481C.357-.4.357-.385.357-.385c0 .083.193.152.248.152s.083-.055.11-.097l1.16-2.48a.4.4 0 0 0 .055-.193m0 0",
    "aria-label": 0,
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(450.172 169.687)scale(1.13333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.062-65.293.002 5.229",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(1.33333 -1.33333)rotate(89.983 182.1 118.665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.761-92.02.002 5.228",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(1.33333 -1.33333)rotate(89.981 201.82 111.66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.927-118.257.002 4.738",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(1.33333 -1.33333)rotate(89.975 225.777 108.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.66-44.124c-11.285 0-21.17 8.43-21.17 19.257",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 84.865 4.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.196 1.594C-1.096.996 0 .1.3 0 0-.1-1.096-.996-1.196-1.594",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.31879,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0 -1.33333 -1.33333 0 338.852 37.696)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(88.009 205.382)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "11.326377 18.236782 26.432072 28.991978 31.551886 34.111794 39.231606 42.866585 46.44149 50.045982 54.653816 58.237686 60.797592 65.405426 73.600716 78.208549 84.099472 87.683342 92.803154 99.969101 103.55297 107.15747 111.2569 118.43182 123.03965 126.64414 131.25198 134.06743 137.65129 140.2112 145.33102 153.00536 157.61319 162.22102 166.82886 169.38876 174.50858 178.14355 184.8029 189.92271 196.19382 203.10422 206.43076 213.34116 219.99692 225.11673",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.9664px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "AnillustrationofthetreegraftingagainstSPHINCS.")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeGraft);
export default __webpack_public_path__ + "static/media/treeGraft.e42c891c388b2b2262688f66a6e8b851.svg";
export { ForwardRef as ReactComponent };